/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module NvappinstallTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

/**
 * API for NvApp Installer CEF plugin - message forwarding between installer backend and UI
 */
export interface Nvappinstall {}
/**
 * Package details for NvApp installer
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "Package".
 */
export interface Package {
    /**
     * Package display name
     */
    title: string;
    /**
     * New version to be installed
     */
    version: string;
}
/**
 * Theme resolved for NvApp installer UI
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "ThemeResult".
 */
export interface ThemeResult {
    theme: ResolvedThemeEnum;
}
/**
 * Current installer state sent from backend to UI
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "InstallerState".
 */
export interface InstallerState {
    method: MethodEnum;
    form: FormEnum;
    installMode?: InstallModeEnum;
    theme?: ThemeEnum;
    /**
     * List of packages being installed
     */
    packages?: Package[];
    /**
     * Installation error code. 0 = success
     */
    errorCode?: number;
    downloadFailureReason?: DownloadFailureReasonEnum;
    /**
     * Identifiers of failed constraints
     */
    failedConstraintId?: string[];
}
/**
 * Installation progress update
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "Progress".
 */
export interface Progress {
    method: MethodEnum;
    form: FormEnum;
    /**
     * Description of current progress step
     */
    progressTitle: string;
    /**
     * Current progress value
     */
    currentProgress: number;
    /**
     * Total progress value
     */
    totalProgress: number;
}
/**
 * Billboard parameters resolved by NvAppInstall for GFWSL URL discovery
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "BillboardParameters".
 */
export interface BillboardParameters {
    /**
     * GPU four-part device identifiers
     */
    dIDa?: string[];
    /**
     * Currently installed display driver version
     */
    GFPV?: string;
}
/**
 * User action/choice sent from UI to backend in response to installer state.
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "UserAction".
 */
export interface UserAction {
    nextAction: NextActionEnum;
}

/**
 * Installation operation mode
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "InstallModeEnum".
 */
export enum InstallModeEnum {
    Install = 0,
    SelfUpdate = 1,
    Uninstall = 2
}
/**
 * Semantic reason for a package download failure
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "DownloadFailureReasonEnum".
 */
export enum DownloadFailureReasonEnum {
    Unknown = 0,
    NetworkFailure = 1,
    SignatureValidationFailure = 2,
    DataWriteFailure = 3
}
/**
 * UI theme preference
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "ThemeEnum".
 */
export enum ThemeEnum {
    Dark = 0,
    Light = 1,
    System = 2
}
/**
 * Resolved UI theme
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "ResolvedThemeEnum".
 */
export enum ResolvedThemeEnum {
    Dark = 0,
    Light = 1
}
/**
 * Message type from backend
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "MethodEnum".
 */
export enum MethodEnum {
    ShowForm = 1,
    ProgressUpdate = 2
}
/**
 * Form identifier matching MsgExchangeLib FormIdentifier
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "FormEnum".
 */
export enum FormEnum {
    NotSet = 0,
    InstallInitial = 1,
    InstallChecking = 2,
    InstallCheckWarnings = 3,
    InstallCheckFailed = 4,
    InstallCheckWait = 5,
    Eula = 6,
    InstallSelect = 7,
    InstallSelectCustom = 8,
    InstallSelectInstallPath = 9,
    PreInstallCheck = 10,
    PreInstallCheckRetry = 11,
    PreInstallCheckWait = 12,
    PreRebootInstall = 13,
    PackageDownloadProgress = 14,
    ProcessDownloadedPackage = 15,
    PackageDownloadFailed = 16,
    InstallProgress = 17,
    InstallRemoveProgress = 18,
    InstallFinished = 19,
    InstallFinishedNoSummary = 20,
    InstallFinishedLaunch = 21,
    InstallFinishedNoSummaryLaunch = 22,
    InstallFinishedOptions = 23,
    InstallFinishedNoSummaryOptions = 24,
    InstallReboot = 25,
    InstallRebootOptions = 26,
    InstallRebootNoSummary = 27,
    InstallRebootNoSummaryOptions = 28,
    InstallRemoveReboot = 29,
    InstallFailed = 30,
    WaitingOnUac = 31,
    UninstallInitial = 32,
    UninstallChecking = 33,
    UninstallConfirm = 34,
    UninstallCheckWarnings = 35,
    UninstallCheckFailed = 36,
    UninstallCheckWait = 37,
    PreUninstallCheck = 38,
    PreUninstallCheckRetry = 39,
    PreUninstallCheckWait = 40,
    PreRebootUninstall = 41,
    UninstallProgress = 42,
    UninstallFinished = 43,
    UninstallReboot = 44,
    UninstallFailed = 45,
    NvAppUpgrade = 46
}
/**
 * User action response
 *
 * This interface was referenced by `Nvappinstall`'s JSON-Schema
 * via the `definition` "NextActionEnum".
 */
export enum NextActionEnum {
    Next = 0,
    Close = 1
}


}
